<template>
  <div class="m-market">
    <!-- outcomes -->
    <template v-if="hasOutcomes">
      <template v-for="(item, index) in marketList">
        <Outcome
          v-if="item"
          :key="`${marketId}-${item.specifiers}`"
          :disabled="!item"
          :outcome="Array.isArray(item.outcomes) ? item.outcomes[0]: item.outcomes.map[item.outcomes.order[0]]"
          :market="item"
          :event="event"
        />

        <Outcome
          v-else
          :key="index"
          :disabled="true"
        />
      </template>
    </template>

    <template v-else>
      <template v-for="item in outcomeNullCount">
        <Outcome
          :key="item"
          :disabled="true"
        />
      </template>
    </template>
  </div>
</template>

<script>
/**
 * 展示列表页 presentationType 为 7 的 market
 */
import Outcome from './Outcome'

export default {
  name: 'SuperMarket7',
  components: {
    Outcome
  },
  props: {
    // 直接传入 market 就直接用
    market: {
      type: Array,
      default: () => null
    },
    markets: {
      type: Object,
      default: () => null
    },
    sportId: {
      type: String,
      default: ''
    },
    marketId: {
      type: [Number, String],
      default: ''
    },
    outcomeSize: {
      type: Number,
      default: 3
    },
    marketTitles: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    // 为空的 outcome 有多少个
    outcomeNullCount() {
      return this.isSpecifiers ? this.outcomeSize - 1 : this.outcomeSize
    },
    hasOutcomes() {
      const { currentMarket } = this
      return currentMarket && currentMarket.length
    },
    currentMarket() {
      if (this.market) return this.market
      return this.markets.map[this.marketId]
    },
    marketList() {
      return this.marketTitles.map((title) => this.getMarket(title))
    }
  },
  methods: {
    getOutcome(outcomes) {
      if (Array.isArray(outcomes)) {
        return outcomes[0]
      }
      return outcomes.map[outcomes.order[0]]
    },
    getMarket(title) {
      return this.currentMarket.find((market) => {
        if (market.outcomes) {
          const { description } = this.getOutcome(market.outcomes)
          return `${description}` === `${title}`
        }
        return false
      })
    }
  }
}
</script>
